export default function NotFound() {
  return <div>未找到页面</div>
}
